import React from 'react';
import RelatedLinks from './RelatedLinks';
import { useFooterLinks } from '../../hooks/useFooterLinks';

const FooterLinks = () => {
  const { quickLinks, resources, legal } = useFooterLinks();
  
  return (
    <div className="lg:col-span-3">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <RelatedLinks title="Quick Links" links={quickLinks} />
        <RelatedLinks title="Resources" links={resources} />
        <RelatedLinks title="Legal" links={legal} />
      </div>
    </div>
  );
};

export default FooterLinks;